import { useState, useEffect } from 'react';
import { useEthPrice } from '../hooks/useEthPrice';
import { useTheme } from '../context/ThemeContext';
import { useDesignMode } from '../context/DesignModeContext';
import { useIsMobile } from '../hooks/useMediaQuery';
import { LegalDisclaimerModal } from './LegalDisclaimerModal';
import { FooterActions } from './FooterActions';
import LanguageSelector from './LanguageSelector';

function Footer() {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const { designMode, setDesignMode } = useDesignMode();
  const { fetchedAt, error } = useEthPrice();
  const [hoverMode, setHoverMode] = useState<number | null>(null);
  const [legalOpen, setLegalOpen] = useState(false);

  useEffect(() => {
    if (!legalOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLegalOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [legalOpen]);

  if (isMobile) {
    return null;
  }

  return (
    <footer
      style={{
        marginTop: 'auto',
        padding: '1.25rem 1.5rem',
        ...(typeof theme.footerBg === 'string' && theme.footerBg.includes('gradient')
          ? { background: theme.footerBg }
          : { backgroundColor: theme.footerBg ?? theme.bgCard }),
        ...(theme.cardStyle === 'glass' && { backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' }),
        borderTop: `1px solid ${theme.border}`,
        fontSize: '0.75rem',
        color: theme.footerTextColor ?? theme.textMuted,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '1rem',
          alignItems: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <FooterActions
          theme={theme}
          designMode={designMode}
          setDesignMode={setDesignMode}
          hoverMode={hoverMode}
          setHoverMode={setHoverMode}
          fetchedAt={fetchedAt}
          priceError={error}
          onLegalClick={() => setLegalOpen(true)}
          layout="inline"
        />
        <span style={{ opacity: 0.4 }}>·</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '0.6875rem', textTransform: 'uppercase', letterSpacing: '0.08em', opacity: 0.8 }}>
            Language
          </span>
          <LanguageSelector />
        </div>
      </div>
      <LegalDisclaimerModal open={legalOpen} onClose={() => setLegalOpen(false)} theme={theme} />
    </footer>
  );
}

export default Footer;
